 export default function UserCache($rootScope) {
  'ngInject'
  this.set = function (user) {
    localStorage.removeItem("user");
    localStorage.setItem("user", JSON.stringify(user));
    $rootScope.username = user.user.name;
    if (user.user.admin !== undefined) {
      $rootScope.admin = true;
    }
    if (user.user.admin !== undefined && user.user.producer === undefined) {
      $rootScope.notProducer = true;
    }
  };

  this.get = function () {
    var user = localStorage.getItem("user");
    if (user !== null) {
      user = JSON.parse(user);
      if (user.user.admin !== undefined) {
        $rootScope.admin = true;
      }
      if (user.user.admin !== undefined && user.user.producer === undefined) {
        $rootScope.notProducer = true;
      }
      $rootScope.username = user.user.name;
      return user.user.name;
    }
  };

  this.getObject = function () {
    var user = localStorage.getItem("user");
    if (user !== null) {
      user = JSON.parse(user);
      return user;
    }
  };

  this.remove = function () {
    localStorage.removeItem("user");
    $rootScope.username = null;
  };
}
